import { font, uTextEllipsis } from 'modules/styles';
import styled from 'styled-components';

export const ContactListItemWrap = styled.li<{ isActive: boolean }>`
    ${font(12, '#000', 'standard')}
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    line-height: 18px;
    cursor: pointer;

    ${(props) => (props.isActive ? 'background: #f5f5f5;' : '')}
    &:hover {
        background: #f5f5f5;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #ebeaea;
    }

    .highlighted-text {
        background-color: #edecd0;
    }
`;

export const ContactListItemContactName = styled.div`
    flex: 3;
    ${uTextEllipsis}
`;

export const ContactListItemContactEmail = styled.div`
    flex: 2;
    ${uTextEllipsis}
`;
